var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "template-data-container" },
    [
      _c(
        "b-row",
        { staticClass: "mb-4" },
        [
          _c("b-col", { attrs: { cols: "12" } }, [
            _c("p", [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("e-sign-package.messages.letsStartByGivingName")
                  ) +
                  "\n        " +
                  _vm._s(_vm.$t("e-sign-package.messages.addASubject")) +
                  "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("b-col", { attrs: { cols: "12" } }, [
            _c("h6", { staticClass: "bold text-grey" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("e-sign-package.templateDetails")) +
                  "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "12", lg: "4" } },
            [
              _c("material-input", {
                attrs: { label: _vm.$t("global.words.name") },
                model: {
                  value: _vm.currentTemplateData.name,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.currentTemplateData,
                      "name",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "currentTemplateData.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "12", lg: "8" } },
            [
              _c("material-input", {
                attrs: { label: _vm.$t("global.words.description") },
                model: {
                  value: _vm.currentTemplateData.description,
                  callback: function ($$v) {
                    _vm.$set(_vm.currentTemplateData, "description", $$v)
                  },
                  expression: "currentTemplateData.description",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "12" } }, [
            _c("h6", { staticClass: "bold text-grey" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.$t("e-sign-package.emailDetails")) +
                  "\n        "
              ),
              _c("span", [
                _c("i", {
                  staticClass: "fa fa-info-circle text-grey ml-2",
                  attrs: {
                    "data-toggle": "tooltip",
                    "data-placement": "top",
                    "data-original-title": _vm.$t(
                      "e-sign-package.messages.addASubject"
                    ),
                  },
                }),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "12", lg: "6" } },
            [
              _c("material-input", {
                attrs: { label: _vm.$t("e-sign-package.emailSubject") },
                model: {
                  value: _vm.currentTemplateData.title,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.currentTemplateData,
                      "title",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "currentTemplateData.title",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "12", lg: "6" } },
            [
              _c("material-input", {
                attrs: { label: _vm.$t("e-sign-package.emailMessage") },
                model: {
                  value: _vm.currentTemplateData.message,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.currentTemplateData,
                      "message",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "currentTemplateData.message",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.shouldIncludeApplicationId,
            expression: "shouldIncludeApplicationId",
          },
        ],
        staticClass: "form-check-input ml-1",
        attrs: { id: "isApplicationIdIncluded", type: "checkbox" },
        domProps: {
          checked: Array.isArray(_vm.shouldIncludeApplicationId)
            ? _vm._i(_vm.shouldIncludeApplicationId, null) > -1
            : _vm.shouldIncludeApplicationId,
        },
        on: {
          change: [
            function ($event) {
              var $$a = _vm.shouldIncludeApplicationId,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 &&
                    (_vm.shouldIncludeApplicationId = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.shouldIncludeApplicationId = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.shouldIncludeApplicationId = $$c
              }
            },
            _vm.updateIsApplicationIdIncluded,
          ],
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "state p-primary ml-4" }, [
        _c("label", [
          _vm._v(_vm._s(_vm.$t("e-sign-package.includeApplicationID"))),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }